import { getMimeTypes } from '../utils/file'

export const ACCEPTED_AUDIO_CONTENT_TYPES = getMimeTypes({ types: ['audio'] })
